<span #dom data-component-type="prosemirror-video" [attr.data-resizable]="isEditable || null">
  <figure [class]="htmlClass || null" [style]="figureStyle">
    <span class="resizer-wrap">
      @if (safeUrl) {
        <iframe [src]="safeUrl" [width]="width" [height]="height"></iframe>
      }
      <div (mousedown)="initResize($event)" class="resize-handle"></div>
    </span>
  </figure>
</span>
